import { render, staticRenderFns } from "./TMP.vue?vue&type=template&id=31480bd7&scoped=true&"
import script from "./TMP.vue?vue&type=script&lang=js&"
export * from "./TMP.vue?vue&type=script&lang=js&"
import style0 from "./TMP.vue?vue&type=style&index=0&id=31480bd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31480bd7",
  null
  
)

export default component.exports